import { useQuery } from '@tanstack/react-query';
import { getAdherenceService } from '../../../domains/adherence';

const isResultOk = (res: any) => res?.result_code === '200' || res?.resultCode === 200;

/**
 * 복약이행관리 탭 상단 KPI 5개 (managed_count / avg_adherence_percent / challenge_count / churn_risk_count / churn_call_count).
 */
export const useAdherenceKpi = (brn: string | null | undefined) => {
  return useQuery({
    queryKey: ['adherence-kpi', brn],
    enabled: !!brn,
    queryFn: async () => {
      const res = await getAdherenceService().getKpiSummary(brn);
      if (!isResultOk(res)) return null;
      return res?.data ?? null;
    },
  });
};
